import * as fx from 'money';
import { toFixed } from 'accounting';
export class MoneyUtil {
  static convert(query: {
    amount: number | string;
    from: string;
    to?: string;
  }) {
    const { amount, from, to } = query;
    return +toFixed(
      fx.convert(amount, {
        from: from?.toUpperCase(),
        to: to?.toUpperCase(),
      }),
      2
    );
  }
}
